import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import {
  getScoringConfig,
  createScoringConfig,
  updateScoringConfig,
  deleteScoringConfig,
} from "../api/scoring.api.js";

// ---------------- GET ALL ScoringS ----------------

// ---------------- GET SINGLE Scoring ----------------
export const useScoringQuery = (id) => {
  return useQuery({
    queryKey: ["Scorings", id],
    queryFn: () => getScoringConfig(id),
    enabled: Boolean(id),
  });
};

// ---------------- CREATE Scoring ----------------
export const useCreateScoringMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => createScoringConfig(id, data),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["Scorings"] });
    },
  });
};

// ---------------- UPDATE Scoring ----------------
export const useUpdateScoringMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => updateScoringConfig(id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["Scorings"] });
      queryClient.invalidateQueries({
        queryKey: ["Scorings", variables.id],
      });
    },
  });
};

// ---------------- DELETE Scoring ----------------
export const useDeleteScoringMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteScoringConfig,

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["Scorings"] });
    },
  });
};
